/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type useAuctionBids_item = {
    readonly relevantAuctionSolution: {
        readonly reserveMet: boolean | null;
        readonly highestBidderId: string | null;
    } | null;
    readonly auctionActiveMaxBids?: ReadonlyArray<{
        readonly userId: string | null;
        readonly amount: {
            readonly convertedAmountList: ReadonlyArray<{
                readonly amount: number | null;
                readonly currency: Currency | null;
            } | null> | null;
        } | null;
    } | null> | null | undefined;
    readonly " $refType": "useAuctionBids_item";
};
export type useAuctionBids_item$data = useAuctionBids_item;
export type useAuctionBids_item$key = {
    readonly " $data"?: useAuctionBids_item$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"useAuctionBids_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "fetchUser"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useAuctionBids_item",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "page",
          "value": "pdp"
        }
      ],
      "concreteType": "AuctionSolution",
      "kind": "LinkedField",
      "name": "relevantAuctionSolution",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "reserveMet",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "highestBidderId",
          "storageKey": null
        }
      ],
      "storageKey": "relevantAuctionSolution(page:\"pdp\")"
    },
    {
      "condition": "fetchUser",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MaxBidType",
          "kind": "LinkedField",
          "name": "auctionActiveMaxBids",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "userId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "FinancialAmount",
              "kind": "LinkedField",
              "name": "amount",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ConvertedAmountList",
                  "kind": "LinkedField",
                  "name": "convertedAmountList",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "amount",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currency",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = 'a11b0da2b851ac69fb1daee2f9b2209d';
export default node;
